import { render } from "./AssetCard.vue?vue&type=template&id=b5cfd06a&scoped=true"
import script from "./AssetCard.vue?vue&type=script&lang=js"
export * from "./AssetCard.vue?vue&type=script&lang=js"

import "./AssetCard.vue?vue&type=style&index=0&id=b5cfd06a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5cfd06a"]])

export default __exports__